document.addEventListener('DOMContentLoaded', () => {
  const iframe = document.querySelector('iframe');

  // Set initial state: Myanmar active
  document.querySelectorAll('.country').forEach((country) => {
    const radiobtn = country.querySelector('.radiobtn');
    const radiofillbtn = country.querySelector('.radiofillbtn');

    if (country.dataset.country === 'myanmar') {
      country.classList.add('active');
      if (radiobtn) radiobtn.style.display = 'none';
      if (radiofillbtn) radiofillbtn.style.display = 'inline';
      if (iframe) iframe.src = country.dataset.map; // show Myanmar map by default
    } else {
      country.classList.remove('active');
      if (radiobtn) radiobtn.style.display = 'inline';
      if (radiofillbtn) radiofillbtn.style.display = 'none';
    }
  });

  // Toggle icons and map on click
  document.querySelectorAll('.country').forEach((country) => {
    country.addEventListener('click', function () {
      document.querySelectorAll('.country').forEach((c) => {
        c.classList.remove('active');
        const rb = c.querySelector('.radiobtn');
        const rfb = c.querySelector('.radiofillbtn');
        if (rb) rb.style.display = 'inline';
        if (rfb) rfb.style.display = 'none';
      });

      this.classList.add('active');
      const rb = this.querySelector('.radiobtn');
      const rfb = this.querySelector('.radiofillbtn');
      if (rb) rb.style.display = 'none';
      if (rfb) rfb.style.display = 'inline';

      // Update iframe map
      if (iframe) {
        iframe.src = this.dataset.map;
      }
    });
  });
});
